import { superPropertiesPlugin } from './super-properties';

export interface AppNameConfig {
  appName: string;
}

export interface AppNameSuperProps extends Record<string, unknown> {
  app_name: string;
}

export function appNamePlugin(config: AppNameConfig) {
  const superPropsPlugin = superPropertiesPlugin<AppNameSuperProps>({
    initialProps: {
      app_name: config.appName,
    },
  });

  return {
    name: 'app-name',
    methods: {
      ...superPropsPlugin.methods,
    },
    trackStart: superPropsPlugin.trackStart,
    pageStart: superPropsPlugin.pageStart,
    identifyStart: superPropsPlugin.identifyStart,
  };
}
